import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./CustomModal.css"; // 👈 importa los estilos

const CustomModal = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "sm",
  fullWidth = true,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        className: "custom-modal-paper",
        style: {
          // border: `0.1vh solid 40`,
          // boxShadow: "0px 0px 25px rgba(233,78,26,0.3)",
        },
      }}
    >
      {/* HEADER */}
      <DialogTitle className="custom-modal-title">
        <Typography variant="h6" className="custom-modal-title-text">
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="custom-modal-close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* CONTENIDO */}
      <DialogContent dividers className="custom-modal-content">
        {children}
      </DialogContent>

      {/* ACCIONES */}
      {actions && (
        <DialogActions className="custom-modal-actions">
          {actions.map((action, idx) => (
            <Button
              key={idx}
              onClick={action.onClick}
              variant={action.variant || "contained"}
              className={`custom-modal-button ${
                idx === 0 ? "btn-gray" : "btn-orange"
              }`}
            >
              {action.label}
            </Button>
          ))}
        </DialogActions>
      )}

    </Dialog>
  );
};

export default CustomModal;

// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Typography,
//   Button,
//   useTheme,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// const CustomModal = ({
//   open,
//   onClose,
//   title,
//   children,
//   actions,
//   maxWidth = "sm",
//   fullWidth = true,
// }) => {
//   const theme = useTheme();

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       // maxWidth={maxWidth}
//       // fullWidth={fullWidth}
//        PaperProps={{
//         sx: {
//           background: "linear-gradient(to bottom, #1a1a1a, #0f0f0f)", // 👈 acorde a botones
//           borderRadius: "1.5vh",
//           border: `0.1vh solid ${theme.palette.primary.main}40`,
//           boxShadow: "0px 0px 25px rgba(233,78,26,0.3)", // 👈 glow anaranjado
//           overflow: "hidden",
//         },
//       }}
//     >
//       {/* HEADER */}
//       <DialogTitle
//         sx={{ p: '1vw', display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: `0.01vw solid ${theme.palette.primary.main}30`,}}
//       >
//         <Typography variant="h6" color={'#c3c3c3'}>
//           {title}
//         </Typography>
//         <IconButton
//           aria-label="close"
//           onClick={onClose}
//           sx={{
//             color: '#c3c3c3',
//             "&:hover": { backgroundColor: "rgba(233, 78, 26, 0.1)" },
//           }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       {/* CONTENIDO */}
//       <DialogContent
//         dividers
//         sx={{
//           p: 2,
//           color: theme.palette.text.secondary,
//           typography: "body1",
//         }}
//       >
//         {children}
//       </DialogContent>

//       {/* ACCIONES */}
//       {actions && (
//         <DialogActions
//           sx={{
//             p: 2,
//             borderTop: `1px solid ${theme.palette.primary.main}30`,
//           }}
//         >
//           {actions.map((action, idx) => (
//             <Button
//               key={idx}
//               onClick={action.onClick}
//               variant={action.variant || "contained"}
//               color={action.color || "primary"}
//               sx={{ textTransform: "none" }}
//             >
//               {action.label}
//             </Button>
//           ))}
//         </DialogActions>
//       )}
//     </Dialog>
//   );
// };

// export default CustomModal;
